/*
* Copyright Gregory Coburn 2020-2026, All Rights Reserved, See license for further details
*/
import { uuid } from "@src/app/model/abstract-object";
import { Team } from "@src/app/model/team";

export class AgentSettings extends Team {
    mailSendingDomain: string;
    mailReplyToDomain: string;
    paymentTerms: string;
    fromEmail: string;
    replyToMail: string;
    billingAddress: string;
    mailSendingAccount: string;
    mailSendingName: string;
    useLogo = 'no';
    showOmcDashboard = 'no';
    /** See AI_LEVELS - the default for every OMC this agency acts for. */
    aiLevel = 'review';
    serviceChargeLabel: string;
    creditNoteLabel: string;
    parameters: { id: uuid, name: string, value: string }[] = [];
}
